module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/BKYS01_login.4fd3f19f.png";